import { useCallback } from 'react';
import type { DomainOrderResponseDto } from '@tiendanube/common';
import { DOMAIN_ORDER_PROCESSING_STATUSES } from '../../../constants';
import { useLazyGetActiveDomainOrderQuery } from '../../../domainsApi';
import { useSequentialPolling } from '../../../hooks';

interface UseActiveOrderPollingParams {
  activeOrder: DomainOrderResponseDto | null | undefined;
  enabled: boolean;
}

export const useActiveOrderPolling = ({
  activeOrder,
  enabled,
}: UseActiveOrderPollingParams): void => {
  const [fetchActiveOrder] = useLazyGetActiveDomainOrderQuery();

  const fetchFn = useCallback(async () => {
    await fetchActiveOrder().unwrap();
  }, [fetchActiveOrder]);

  const isProcessing =
    activeOrder &&
    DOMAIN_ORDER_PROCESSING_STATUSES.includes(activeOrder.status);
  const shouldPoll = Boolean(isProcessing);

  useSequentialPolling({
    fetchFn,
    shouldPoll,
    enabled,
    skipFirstImmediate: true,
  });
};
